import styled from 'styled-components'

export const Wrapper = styled.div<{ image: string }>`
  position: relative;
  background-size: cover;
  background-position: center center;
  background-repeat: no-repeat;
  width: 100%;
  height: 700px;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  padding: 0 16px;
  box-sizing: border-box;

  &::before {
    border-radius: 20px;
    content: '';
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    box-sizing: border-box;
    /* TODO review image */
    background-image: url('${({ image }) => image}');
    background-size: cover;
    background-repeat: no-repeat;
    background-position: center center;
    z-index: 0;
  }

  & > h1 {
    z-index: 1;
    color: white;
    position: relative;
    text-align: center;
  }

  & > h2 {
    color: white;
    text-align: center;
    z-index: 1;
    font-weight: var(--font-medium);
  }

  @media (max-width: 600px) {
    height: 360px;

    & > h1 {
      margin-bottom: 10px;

      & > div {
        left: 50%;
        transform: translateX(-50%);
      }
    }

    & > h2 {
      font-size: 14px;
    }
  }
`
export const SearchWrapper = styled.div`
  position: relative;

  & > input {
    border-radius: 100px;
    width: 445px;
    height: 55px;
    padding: 12px 60px 12px 24px;

    &::placeholder {
      color: var(--brand-secondary);
    }
  }

  & > button {
    position: absolute;
    top: 50%;
    right: -22px;
    transform: translate(-50%, -50%);
    font-size: 12px;
    border-radius: 50%;
    width: 50px;
    height: 50px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-weight: var(--font-bold);
  }

  @media (max-width: 600px) {
    width: 90%;

    & > input {
      width: 300px;
    }
  }
`

export const IconWrapper = styled.div`
  svg {
    width: 128px;
    height: 128px;
    position: absolute;
    bottom: 20px;
    right: 20px;
    z-index: 1;
  }

  @media (max-width: 600px) {
    svg {
      width: 60px;
      height: 60px;
      bottom: 10px;
      right: 10px;
      zindex: 1;
    }
  }
`
